/**
 * NOTE: WIP - this is stub component hidden behind a feature flag
 */

export enum RuleVariant {
  Default = 'default',
  Custom = 'custom',
}

type Props = {
  variant: RuleVariant
  viewOnly: boolean
}

export const RuleUpsert: React.FC<Props> = ({ variant, viewOnly = true }) => {
  return <div>RuleUpsert</div>
}
